import { SURVEY_LINK } from './constants';

export const redirectToSurvey = () => {
    window.location.href = SURVEY_LINK;
};
